import moment from "moment";
import { startCase } from "lodash";
import { getAppBaseUrl } from "../../../helpers/urls";
import { ServiceProvider } from "../../../interfaces/ServiceProvidersInterface";

export const getQRUrl = (clientId: string): string => `${getAppBaseUrl()}/clients/${clientId}`;

export const getSpFullName = (sp: ServiceProvider): string =>
  startCase(`${sp?.title || ""} ${sp?.firstName || ""} ${sp?.lastName || ""}`);

export function getClientGender(gender: string): string {
  if (gender === "1") return "M";
  if (gender === "2") return "F";
  return "";
}

export function getClientAge(dob: moment.MomentInput, yearsOnly = false): string {
  const birthDate = moment(dob);
  const now = moment();

  const years = now.diff(birthDate, "years");

  // Only apply yearsOnly to people who are at least 1 year old.
  if (yearsOnly && years >= 1) {
    return `${years}yrs`;
  }

  const duration = moment.duration(now.diff(birthDate));
  const months = duration.months();
  const days = duration.days();

  if (years > 0) {
    return `${years}yrs ${months}m ${days}d`;
  }

  if (months > 0) {
    return `${months}m ${days}d`;
  }

  return `${days}d`;
}
